import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            if (confirm("O portal foi atualizado. Clique aqui para recarregar ou recarregue a página do navegador")) {
                window.location.reload();
            }
        }
    }
}